export enum EExternalEditorType {
  None = '',
  Docs = 'docs',
}
